import Vue from '@/vue'
import MaintenanceNotification from '@/components/MaintenanceNotification.vue'

if (document.getElementById('maintenance-notification')) {
  new Vue({
    el: '#maintenance-notification',
    components: {
      MaintenanceNotification
    }
  })
}
